<template>
<link v-if="isUmbraco" rel="stylesheet" href="/assets/index.css" />

  <section ref="containerRef" :class="containerStyles">
    <header2
      :text="title"
      :is-umbraco="isUmbraco"
      :theme="themeType"
      classes="mb-8 col-start-2 col-span-12 lg:mb-12"
    />

    <div
      class="relative z-30 col-span-full flex overflow-x-auto no-scrollbar 2xl:row-1 2xl:col-span-10 mb-6 2xl:mb-12 2xl:overflow-x-visible"
      v-if="showRegion"
    >
      <a
        v-for="region in uniqueRegions"
        :key="region"
        :href="`#region-${region}`"
        class="overflow-hidden inline-block group relative text-button border-2 text-aubergine border-aubergine-40 hover:border-aubergine mr-4 shrink-0 first:mx-5 md:first:ml-8 md:last:mr-8 lg:first:ml-12 lg:last:mr-[108px] 2xl:first:ml-20 linkTransition px-4 py-2"
      >
        {{ region }}
      </a>
    </div>
    <!-- Employee lists grouped by region -->
    <div
      class="col-span-full flex flex-col gap-10 px-6 md:px-0 lg:col-start-2 lg:col-span-12"
      v-if="showRegion"
    >
      <div
        class="border-b-2 border-aubergine-40 pb-8 mb-8 last:border-0"
        v-for="region in uniqueRegions"
        :key="region as string"
        :id="`region-${region}`"
      >
        <div
          class="col-span-full grid grid-col-12 overflow-auto whitespace-nowrap no-scrollbar px-6 md:px-0 col-start-0 lg:col-start-2 lg:col-span-12 lg:grid lg:grid-cols-12 lg:gap-x-12 2xl:gap-x-20"
        >
          <div class="col-span-full">
            <h3
              class="h3 text-typography mb-8 col-start-2 col-span-12 lg:mb-4 themeTransition"
            >
              {{ region }}
            </h3>
          </div>

          <employee
            v-for="employee in employeesByRegion[region]"
            :key="employee.name"
            :employee="employee"
            :is-umbraco="isUmbraco"
            :theme-type="themeType"
            classes="min-w-[250px] max-w-[290px] mb-4 mr-5 md:mr-8 whitespace-normal last:mr-0 lg:col-span-3 lg:min-w-full lg:max-w-fulllg:mr-0 mb-6 lg:mb-12"
          />
        </div>
      </div>
    </div>
    <div
      class="col-span-full flex overflow-auto whitespace-nowrap no-scrollbar px-6 md:px-10 lg:col-start-2 lg:col-span-12 lg:grid lg:grid-cols-12 lg:gap-x-12 2xl:gap-x-20"
      v-else
    >
      <employee
        v-for="employee in employeesArray"
        :key="employee.name"
        :employee="employee"
        :is-umbraco="isUmbraco"
        :theme-type="themeType"
        classes="min-w-[250px] max-w-[290px] mr-5 md:mr-8 whitespace-normal last:mr-0 lg:col-span-3 lg:min-w-full lg:max-w-fulllg:mr-0 mb-6 lg:mb-12"
      />
    </div>
  </section>
</template>
<script setup lang="ts">
import { onIntersect } from "@/composables/onIntersect";
import { changeTheme, getThemeType } from "@/util/helper";
import { Ref, computed, onMounted, onUnmounted, ref, toRefs } from "vue";
import Employee from "@molecules/Employees/Employee.vue";
import Header2 from "@components/Typography/Header2.ce.vue";
import { IEmployeesProps } from "@/types/components/IEmployeesProps";

const props = withDefaults(defineProps<IEmployeesProps>(), {
  isUmbraco: false,
});
const { theme, isUmbraco, employees, title, showRegion } = toRefs(props);

const observer: Ref<IntersectionObserver | null> = ref(null);
const containerRef = ref(null);

const onEnter = () => {
  if (!theme.value) return;
  changeTheme(theme.value);
};
const onExit = () => {};

onMounted(() => {
  observer.value = onIntersect(containerRef.value, onEnter, onExit, false, {
    threshold: 0.6,
  });
});

onUnmounted(() => {
  if (!observer.value) return;
  observer.value.disconnect();
});

const employeesArray = computed(() => {
  return JSON.parse(employees.value);
});

// Group employees by region
const employeesByRegion = computed(() => {
  return uniqueRegions.value.reduce((acc, region) => {
    acc[region] = employeesArray.value.filter((emp) => emp.employeeRegion === region);
    return acc;
  }, {} as Record<string, typeof employeesArray.value>);
});

// Compute unique regions
const uniqueRegions = computed(() => {
  console.log("props: ", props);
  console.log("isUmbraco", isUmbraco?.value);
  console.log("showRegion: ", showRegion?.value);
  const regions = employeesArray.value.map((emp) => emp.employeeRegion);
  return [...new Set(regions)]; // Remove duplicates
});

const containerStyles = computed(() => {
  const bgColor = isUmbraco?.value ? `bg-${theme.value}` : "";
  return `${bgColor} sectionContainer py-20`;
});

const themeType = computed(() => {
  if (!theme.value) return "dark";
  return getThemeType(theme.value);
});
</script>
